<div class="showBg">
  <div class="login-container" style="padding: 20px;">
    <div *ngIf="errorMessage" class="alert alert-danger small p-2 w-100" style="max-width: 400px;">
      {{ errorMessage }}
    </div>

    <div class="loginLogo"></div>

    <div class="login-card card p-4 shadow">

      <div class="text-center mb-4 " style="font-weight: bold;font-size: 20px;">
        {{ 'FORGOT_PASSWORD.TITLE' | translate }}
      </div>

      <div *ngIf="step === 1">
        <form #step1Form="ngForm" (ngSubmit)="onSendCode()">
          <div class="mb-3">
            <label class="form-label" style="font-weight: bold;">{{ 'FORGOT_PASSWORD.EMAIL_LABEL' | translate }}</label>
            <input type="email" class="form-control form-control-sm" [(ngModel)]="email" name="email" required email
              #emailInput="ngModel" [placeholder]="'FORGOT_PASSWORD.EMAIL_PLACEHOLDER' | translate"
              [disabled]="isLoading">

            <div *ngIf="emailInput.invalid && (emailInput.dirty || emailInput.touched)" class="text-danger mt-1 small">
              <div *ngIf="emailInput.errors?.['required']">{{ 'VALIDATION.EMAIL_REQUIRED' | translate }}</div>
              <div *ngIf="emailInput.errors?.['email']">{{ 'VALIDATION.EMAIL_INVALID' | translate }}</div>
            </div>
          </div>

          <button type="submit" class="btn button-primary-purple w-100 btn-sm"
            [disabled]="step1Form.invalid || isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
            {{ 'FORGOT_PASSWORD.SEND_CODE_BUTTON' | translate }}
          </button>
        </form>
      </div>

      <div *ngIf="step === 2">

        <form #step2Form="ngForm" (ngSubmit)="onResetSubmit()" >
          <div class="mb-3">
            <label class="form-label" style="font-weight: bold;">{{ 'FORGOT_PASSWORD.CODE_LABEL' | translate }}</label>
            <p class="small mb-3">{{ 'FORGOT_PASSWORD.CODE_SENT_TIP' | translate }}</p>

            <div class="input-group input-group-sm">
              <input type="text" class="form-control" [(ngModel)]="code" name="code" required #codeInput="ngModel"
                [placeholder]="'FORGOT_PASSWORD.CODE_PLACEHOLDER' | translate" [disabled]="isLoading"  autocomplete="off">

            </div>
            <div class="text-center "  style="margin-top: 20px;" >{{ 'FORGOT_PASSWORD.RESEND_CODE_LABEL' | translate }}
              <span *ngIf="countdown > 0" style="color: #6c757d;" >{{ 'FORGOT_PASSWORD.RESEND_CODE' | translate }}</span>
              <span *ngIf="countdown > 0" style="color: #6c757d;">({{ countdown }}{{ 'FORGOT_PASSWORD.COUNTDOWN_UNIT' | translate }})</span>
              <span *ngIf="countdown === 0" style="text-decoration: underline;color: #0d6efd;"
                (click)="onResendCode()">{{ 'FORGOT_PASSWORD.RESEND_CODE' | translate }}</span>
            </div>
            <!-- <button class="btn btn-outline-secondary" [disabled]="countdown > 0 || isLoading">
              <span *ngIf="countdown > 0">{{ countdown }}{{ 'FORGOT_PASSWORD.COUNTDOWN_UNIT' | translate }}</span>
              <span *ngIf="countdown === 0">{{ 'FORGOT_PASSWORD.RESEND_CODE' | translate }}</span>
            </button> -->
            <div *ngIf="codeInput.invalid && (codeInput.dirty || codeInput.touched)" class="text-danger mt-1 small">
              <div *ngIf="codeInput.errors?.['required']">Code is required</div>
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label" style="font-weight: bold;">{{ 'FORGOT_PASSWORD.NEW_PASSWORD_LABEL' | translate
              }}</label>
            <input [type]="showNewPassword ? 'text' : 'password'" class="form-control form-control-sm"
              [(ngModel)]="newPassword" name="newPassword" required minlength="6" #pwdInput="ngModel"
              [disabled]="isLoading"  autocomplete="off">
            <div *ngIf="pwdInput.invalid && (pwdInput.dirty || pwdInput.touched)" class="text-danger mt-1 small">
              <div *ngIf="pwdInput.errors?.['required']">{{ 'VALIDATION.PASSWORD_REQUIRED' | translate }}</div>
              <div *ngIf="pwdInput.errors?.['minlength']">{{ 'VALIDATION.PASSWORD_MINLENGTH' | translate }}</div>
            </div>
          </div>
          <div class="mb-3 form-check">
            <input type="checkbox" class="form-check-input" id="showNewPwd" (change)="toggleShowNewPassword()" >
            <label class="form-check-label small" for="showNewPwd">{{ 'LOGIN.SHOW_PASSWORD' | translate }}</label>
          </div>
          
          <div class="mb-3">
            <label class="form-label" style="font-weight: bold;">{{ 'FORGOT_PASSWORD.CONFIRM_PASSWORD_LABEL' | translate
              }}</label>
            <input [type]="showConfirmPassword ? 'text' : 'password'" class="form-control form-control-sm"
              [(ngModel)]="confirmPassword" name="confirmPassword" required #confirmPwdInput="ngModel"
              [disabled]="isLoading"  autocomplete="off">
            <div *ngIf="(confirmPwdInput.dirty || confirmPwdInput.touched)" class="text-danger mt-1 small">
              <div *ngIf="confirmPwdInput.errors?.['required']">Confirmation is required</div>
              <div *ngIf="newPassword !== confirmPassword"> {{ 'VALIDATION.PASSWORDS_DO_NOT_MATCH' | translate }} </div>
            </div>
          </div>

          <div class="mb-3 form-check">
            <input type="checkbox" class="form-check-input" id="showConfirmPwd" (change)="toggleShowConfirmPassword()">
            <label class="form-check-label small" for="showConfirmPwd">{{ 'LOGIN.SHOW_PASSWORD' | translate }}</label>
          </div>

          <button type="submit" class="btn button-primary-purple w-100 btn-sm"
            [disabled]="step2Form.invalid || newPassword !== confirmPassword || isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
            {{ 'FORGOT_PASSWORD.CONFIRM_BUTTON' | translate }}
          </button>
        </form>
      </div>

      <div *ngIf="step === 3" class="text-center py-3">
        <div class="text-success mb-3" style="font-size: 3.5rem;">✓</div>
        <p class="text-success fw-bold">{{ 'FORGOT_PASSWORD.SUCCESS_MESSAGE' | translate }}</p>
        <a routerLink="/login" class="btn button-primary-purple w-100 btn-sm mt-3">
          {{ 'FORGOT_PASSWORD.LOGIN_NOW' | translate }}
        </a>
      </div>

      <div class="text-center mt-3" *ngIf="step !== 3" style="text-decoration: underline">
        <a routerLink="/login" class="text-decoration-none small">{{ 'FORGOT_PASSWORD.BACK_TO_LOGIN' | translate }}</a>
      </div>

    </div>
  </div>
</div>